export const MAX_CONTENT_WIDTH = '1200px';
